import { render, staticRenderFns } from "./DialogSendTDEmail.vue?vue&type=template&id=52b266e3&"
import script from "./DialogSendTDEmail.vue?vue&type=script&lang=js&"
export * from "./DialogSendTDEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports